import { getStorageKey, isDemoMode } from './runtimeMode';

const MAINTENANCE_LOG_ACCESS_EMAILS = new Set([
  'steveh@diamondvalley.town',
  'cao@diamondvalley.town',
  'sy1951901albertaltd@shaw.ca'
]);

const DEMO_MAINTENANCE_LOG_ACCESS_EMAILS = new Set([
  '3p3fleet@gmail.com',
  '3p3cao@gmail.com',
  'ctdemo.cao@proton.me'
]);

const MAINTENANCE_DELEGATE_TOKEN_STORAGE_KEY = 'maintenanceDelegateToken';
const MAINTENANCE_DELEGATE_TOKEN_QUERY_PARAM = 'delegateToken';

export const hasMaintenanceLogAccessEmail = (email) => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  return MAINTENANCE_LOG_ACCESS_EMAILS.has(normalizedEmail)
    || (isDemoMode() && DEMO_MAINTENANCE_LOG_ACCESS_EMAILS.has(normalizedEmail));
};

const getMaintenanceDelegateTokenStorageKey = () => getStorageKey(MAINTENANCE_DELEGATE_TOKEN_STORAGE_KEY);

export const getMaintenanceDelegateToken = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return '';
  }

  return String(window.sessionStorage.getItem(getMaintenanceDelegateTokenStorageKey()) || '').trim();
};

export const persistMaintenanceDelegateToken = (token) => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }

  const normalizedToken = String(token || '').trim();
  if (!normalizedToken) {
    window.sessionStorage.removeItem(getMaintenanceDelegateTokenStorageKey());
    return;
  }

  window.sessionStorage.setItem(getMaintenanceDelegateTokenStorageKey(), normalizedToken);
};

export const clearMaintenanceDelegateToken = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }

  window.sessionStorage.removeItem(getMaintenanceDelegateTokenStorageKey());
};

export const extractMaintenanceDelegateTokenFromSearch = (search) => {
  const params = new URLSearchParams(String(search || ''));
  return String(params.get(MAINTENANCE_DELEGATE_TOKEN_QUERY_PARAM) || '').trim();
};

export const buildMaintenanceAccessHeaders = (token = getMaintenanceDelegateToken()) => {
  const normalizedToken = String(token || '').trim();
  return normalizedToken ? { 'x-maintenance-delegate-token': normalizedToken } : {};
};

export const stripMaintenanceDelegateTokenFromUrl = (pathname, search = '', hash = '') => {
  const params = new URLSearchParams(String(search || ''));
  params.delete(MAINTENANCE_DELEGATE_TOKEN_QUERY_PARAM);
  const nextSearch = params.toString();
  return `${pathname}${nextSearch ? `?${nextSearch}` : ''}${hash || ''}`;
};
